const video_iframe = (callback) => {
   if (document.readyState != "loading") callback();
   else document.addEventListener("DOMContentLoaded", callback);
};

video_iframe(() => {
   const videoWrapper = document.querySelector('.data-video-inner');
   const playButton = document.querySelector('.js-video-play');
   const videoPreview = document.querySelector('.data-video-preview');
   const videoWrapperIframe = document.querySelector('.data-video-iframe');

   if (videoWrapper && playButton && videoPreview && videoWrapperIframe) {
      const iframe = videoWrapperIframe.querySelector('iframe');

      videoWrapper.addEventListener('click', function () {
         videoPreview.classList.add('hidden');
         videoWrapperIframe.classList.add('show');
         playButton.classList.add('hidden');

         if (iframe && !iframe.dataset.srcSet) {
            iframe.dataset.srcSet = 'true';
            
            // Checking the screen width
            if (window.innerWidth > 768) {
               // Add only autoplay and playsinline
               iframe.src += (iframe.src.includes('?') ? '&' : '?') + "autoplay=1&playsinline=1";
            } else {
               iframe.src += (iframe.src.includes('?') ? '&' : '?') + "autoplay=1&mute=1&playsinline=1";
            } // Add autoplay, mute and playsinline parameters

         }
      });
   }
});